import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { PartnersTableBaseZod } from '../tables';

// Accepts any directPartnerId — including those in mergedDirectPartnerIds.
// The resolver checks the primary directPartnerId first, then mergedDirectPartnerIds.
type Arguments = {
    directPartnerId: number;
};

// Deliberately reduced to the fields the lead partner dialog shows. This resolver is open to advisers,
// so it must not expose banking or commission data — use getPartner for the full record.
export const schemaPartnerResolver_GetPartnerByDirectPartnerId = PartnersTableBaseZod.pick({
    direct_partner_company_name: true,
    direct_partner_first_name: true,
    direct_partner_id: true,
    direct_partner_last_name: true,
    direct_partner_name: true,
    email: true,
    hgb84_level: true,
    hgb93_level_bf: true,
    hgb93_level_pk: true,
    hubspot_url: true,
    id: true,
    onboarding_status: true,
    partner_level: true,
    phone: true,
}).nullable();

export type SchemaPartnerResolver_GetPartnerByDirectPartnerId = z.infer<
    typeof schemaPartnerResolver_GetPartnerByDirectPartnerId
>;
export type PartnerResolver_GetPartnerByDirectPartnerId = Resolver<
    Arguments,
    SchemaPartnerResolver_GetPartnerByDirectPartnerId
>;
